<template>
  <div class="flex flex-col input-group-custom">
    <template v-if="tooltip">
      <label for="my_input" class="flex items-center mb-2">
        <span>{{ title }}</span>
        <span class="ml-1">
          <AdvancedTooltip :title="tooltip" theme="blue">
            <IconTooltip/>
          </AdvancedTooltip>
        </span>
      </label>
    </template>
    <template v-else-if="title">
      <label for="my_input" class="flex mb-2">{{ title }}</label>
    </template>
    <textarea
        id="my_input"
        :name="name"
        class="border border-border rounded-md px-3 items-center py-2 w-full"
        :value="inputValue"
        :placeholder="placeholder"
        :disabled="disabled"
        :readonly="readonly"
        @input="handleChange"
        @blur="handleBlur"
    ></textarea>
    <div class="text-error" v-if="errorMessage">{{ errorMessage }}</div>
  </div>
</template>
<script setup lang="ts">
import {useField} from "vee-validate";
import IconTooltip from "@/components/svg_icons/IconTooltip.vue";
import AdvancedTooltip from "@/components/tooltip/AdvancedTooltip.vue";

const props = defineProps({
  type: {
    type: String,
    required: false,
    default: 'text'
  },
  modelValue: {
    type: String,
    required: false,
    default: ''
  },
  name: {
    type: String,
    required: false,
    default: ''
  },
  title: {
    type: String,
    required: false,
    default: ''
  },
  placeholder: {
    type: String,
    required: false,
    default: ''
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false
  },
  readonly: {
    type: Boolean,
    required: false,
    default: false
  },
  tooltip: {
    type: String,
    required: false,
    default: ''
  },

});

const {
  value: inputValue,
  errorMessage,
  handleBlur,
  handleChange,
  meta,
} = useField(props.name, undefined, {
  initialValue: props.modelValue,
  syncVModel: true,
});

//const emit = defineEmits(["update:modelValue"])
</script>
